import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Button } from "@mui/material";
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { ShoppingCartWithItems } from 'common-models';
import { FC } from 'react';

type ShoppingCartsListProps = {
    shoppingCarts: Array<ShoppingCartWithItems>;
    onDeleteCart: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    getCurrentCartState: (cart: ShoppingCartWithItems) => React.JSX.Element;
};

/**
 * ShoppingCartsList component - displays a list of shopping carts in the admin interface
 * with responsive grid layout and delete functionality.
 */
const ShoppingCartsList: FC<ShoppingCartsListProps> = ({
    shoppingCarts,
    onDeleteCart,
    getCurrentCartState
}) => {
    return (
        <>
            <Grid container>
                <h1>Shopping carts</h1>
            </Grid>
            <Grid container>
                {
                    shoppingCarts.map(x => <Grid key={x.id} container className={classes.cartFrame} >
                        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 2 }}>{x.createdTime.toISOString()}</Grid>
                        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 2 }}>{x.items.length} items</Grid>
                        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 2 }}>Total: SEK {x.totalSum} ({x.totalSum * 1.25} incl VAT)</Grid>
                        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 2 }}>
                            <Grid size="auto">{x.isOpen ? 'Open' : 'Closed'}</Grid>{getCurrentCartState(x)}</Grid>
                        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 2 }}><Button
                            variant='text'
                            onClick={onDeleteCart}
                            value={x.id}
                        >
                            <DeleteForeverIcon />
                        </Button></Grid>
                    </Grid>)
                }
            </Grid >
        </>
    );
};

const PREFIX = 'ShoppingCartsList';
const classes = {
    cartFrame: `${PREFIX}-cartFrame`,
};

const Root = styled('div')(({ theme }) => ({
    [`&.${classes.cartFrame}`]: {
        borderStyle: 'solid',
        borderWidth: '1px',
        borderColor: theme.palette.text.secondary,
        borderRadius: '0.3rem',
        margin: '0.5rem'
    },
}));

export { ShoppingCartsList };
